// extracted by mini-css-extract-plugin
export default {"form":"AddParishBookPersonView_form__GxqlT","description":"AddParishBookPersonView_description__i9LnR","error":"AddParishBookPersonView_error__0XCT+"};